module.exports = __webpack_public_path__ + "img/rav.a3e0c641.jpg";